<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">Devenir Client</h4>
          <form form @submit.prevent="handleRegister">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10"
                >Nom complet (*)</label
              >
              <input
                type="text"
                v-model="form.name"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse electronique (*)
              </label>
              <input
                type="email"
                v-model="form.email"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Numéro de téléphone (*)
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                v-model="form.phone"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Ville (*)
              </label>
              <input
                type="text"
                v-model="form.city"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>

            <div
              class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20"
            >
              <input
                class="form-check-input shadow-none"
                type="checkbox"
                id="remember-me"
                v-model="form.status"
                true-value="1"
                false-value="0"
              />
              <label class="form-check-label" for="remember-me">
                J'accepte tous les
                <a href="#" class="text-decoration-none"
                  >termes et conditions</a
                >
              </label>
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              type="submit"
              :disabled="load || form.status == 0"
            >
              <div class="spinner-border" v-if="load" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              S'inscrire
            </button>
            <span
              class="d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
            >
              Vous avez déjà un compte ?
            </span>
            <router-link
              to="/login"
              class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            >
              Se connecter
            </router-link>
            <!-- <span
              class="d-block or text-muted text-center mt-15 mb-15 mt-md-20 mb-md-20 fs-md-15 fs-lg-16 position-relative z-1 lh-1"
            >
              <span class="d-inline-block bg-white">Ou</span>
            </span>
            <ul class="socials ps-0 mb-0 list-unstyled text-center">
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative facebook border-0 p-0"
                >
                  <i class="ph-fill ph-facebook-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative google border-0 p-0"
                >
                  <i class="ph-bold ph-google-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative twitter border-0 p-0"
                >
                  <i class="ph-fill ph-twitter-logo"></i>
                </button>
              </li>
              <li class="d-inline-block">
                <button
                  type="button"
                  class="d-block rounded-circle text-center position-relative linkedin border-0 p-0"
                >
                  <i class="ph-fill ph-linkedin-logo"></i>
                </button>
              </li>
            </ul> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";
import api from "@/utils/axios";
import { defineComponent, reactive, ref } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const { sanitizeText } = useSanitize();

    const form = ref({
      email: "",
      name: "",
      phone: "",
      city: "",
      status: 1,
      store: {
        name: "",
        id: "",
      },
    });
    const load = ref(false);
    const isCreat = ref(false);

    const handleRegister = async () => {
      console.log(form.value);
      const regex = /^[a-zA-Z0-9\s]+$/;
      // Simple validation
      if (
        form.value.name &&
        form.value.email &&
        form.value.phone &&
        form.value.city
        // &&
        // form.value.status === 1
        // && regex.test(form.value.name)
      ) {
        let data = new FormData();
        data.append("name", sanitizeText(form.value.name));
        data.append("phone", sanitizeText(form.value.phone));
        data.append("email", sanitizeText(form.value.email));
        data.append("city", sanitizeText(form.value.city));
        // data.append('store_name', form.value.store.name ? form.value.store.name : '');
        // data.append('store_id', form.value.store.id ? form.value.store.id : '');
        load.value = true;
        try {
          const res = await api.post(`/api/auth/client/Register`, data);
          load.value = false;
          if (res.data.message === "success") {
            form.value = {
              email: "",
              name: "",
              phone: "",
              city: "",
              status: 1,
              store: {
                name: "",
                id: "",
              },
            };
            isCreat.value = true;
            showToast(
              "Compte créé avec succès! Veuillez vérifier votre e-mail pour l'activation.",
              "success"
            );
          } else if (res.data.message === "email exist") {
            showToast(
              "Cet e-mail existe déjà. Veuillez utiliser un autre e-mail.",
              "warning"
            );
          }
        } catch (e) {
          load.value = false;
          showToast("Une erreur s'est produite. Veuillez réessayer.", "error");
        }
      } else {
        showToast("Merci de verifier tous les champs", "warning");
      }
    };

    return {
      form,
      load,
      isCreat,
      handleRegister,
    };
  },
});
</script>
    